export default {
    login: {
        title: 'Login',
    },
}
